import * as React from 'react';
import { EControlType, EArrowsSize } from '../../types';
import { DEFAULT_ARROW_ICON_SIZE, DEFAULT_CONTROLS_OFFSET, DEFAULT_LARGE_ARROW_ICON_SIZE } from '../../constants';
import { getControlSettings } from '../../helpers';
import { SlidesContainer } from '../SlidesContainer';
import { DefaultCounter } from '../DefaultCounter';
import { DefaultArrows } from '../DefaultArrows';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Carousel = function Carousel(props) {
  var width = props.width,
    slidesLeftOffset = props.slidesLeftOffset,
    slides = props.slides,
    currentSlide = props.currentSlide,
    totalSlides = props.totalSlides,
    slidesToShow = props.slidesToShow,
    slidesContainerRef = props.slidesContainerRef,
    handleArrowClick = props.handleArrowClick,
    defaultControls = props.defaultControls,
    defaultArrowStyles = props.defaultArrowStyles,
    handleSlideClick = props.handleSlideClick,
    arrowsSettings = props.arrowsSettings;
  var counter = getControlSettings(EControlType.COUNTER, defaultControls);
  var arrows = getControlSettings(EControlType.ARROWS, defaultControls);
  var arrowIconSize = arrowsSettings.size === EArrowsSize.NORMAL ? DEFAULT_ARROW_ICON_SIZE : DEFAULT_LARGE_ARROW_ICON_SIZE;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SlidesContainer, {
      slideWidth: width.slide,
      gapWidth: width.gap,
      slides: slides,
      leftOffset: slidesLeftOffset,
      ref: slidesContainerRef,
      handleSlideClick: handleSlideClick
    }), arrows && /*#__PURE__*/_jsx(DefaultArrows, {
      leftAreaWidth: "".concat(width.leftEar + width.gap + DEFAULT_CONTROLS_OFFSET + arrowIconSize, "px"),
      rightAreaWidth: "".concat(width.rightEar + width.gap + DEFAULT_CONTROLS_OFFSET + arrowIconSize, "px"),
      showLeft: currentSlide > slidesToShow,
      showRight: currentSlide < totalSlides,
      clickHandler: handleArrowClick,
      styles: defaultArrowStyles,
      size: arrowsSettings.size
    }), counter && totalSlides > slidesToShow && /*#__PURE__*/_jsx(DefaultCounter, {
      currentSlide: currentSlide,
      totalSlides: totalSlides,
      rightOffset: "".concat(width.rightEar + width.gap + DEFAULT_CONTROLS_OFFSET, "px")
    })]
  });
};